// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form-all {
  background-color: white;
  margin-bottom: 2%;
  padding: 0.5%;
}
.contact-container {
  display: grid;
  grid-template-columns: 1.5fr 1fr; 
  gap: 1em;
  background-color: white;
  
  
}

.blue-title {
  font-family: "Rubik", sans-serif;
  font-weight: 800;
  display: flex;
  justify-content: center;
  color: #11224E;
  font-size: 2.2em; 
  margin-bottom: 0.5em; 
}

.contact-info {
  padding-left: 20%; 
}

input::placeholder { 
  font-family: "Open Sans", sans-serif;
  font-size: 1em; 
  font-weight: 500;
  color: rgb(69, 69, 69);
}

.mail { 
text-decoration: none;
}

.contact-info .about{
  font-weight: 300;
  font-size: 1.3em; 
  color: #11224E;
  text-align: justify;
}

.contact-info .mail{
  font-weight: bold;
  font-size: 1.2em; 
  color: #11224E;
  text-align: justify;
}

.contact-info .phone {
  font-weight: lighter;
  font-size: 1.3em; 
  color: #11224E;
  text-align: justify;
}

.contact-form {
  padding-right: 20%;
  height: 110%;
}

.contact-form form {
  display: flex;
  flex-direction: column;
  margin-top: 1em;
}

.contact-form input {
  width: 40%;
  border: none;
  border-bottom: 0.10em solid #11224E; 
  font-size: 1em; 
  margin-bottom: 2.3em;
}

.form-text {
  display: flex;
  flex-direction: column;
  border: none;
  font-size: 1em; 
  margin-bottom: 2em;
}


#message {
  width: 100%;
}

.contact-form button {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #c44e00;
  color: white;
  border: none;
  border-radius: 0.5em; 
  font-size: 1.5em; 
  font-weight: normal; 
  cursor: pointer;
}

.contact-form button:hover {
  background-color: #d27000;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.200em; 
}

.social-logo  { 
  display: flex;
  width: 14em; 
  height: auto;
}
.social-logo img  { 
 width: 40%;
 padding: 5%;
}

.notification {
  position: fixed;
  bottom: 0;  
  right: 0;   
  background-color: #c44e00;
  color: #000;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  align-items: center;
}

.notification p {
  margin: 10px;
}

.accessibility-link {
  margin-top: 1rem;
  text-align: center;
}

.accessibility-link a {
  font-size: 1em;
}

.accessibility-link a:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 768px) {
  .contact-container {
    display: flex;
    flex-direction:column-reverse ;
    grid-template-columns: 1fr; 
  }

  .blue-title {
    margin-bottom: 0.5em; 
    text-align: center;
    
  }

  .contact-info,
  .contact-form {
    padding-inline: 5%; 
  }

  .contact-form input,
  #message,
  .form-text {
    width: 100%; 
  }

  .contact-form button {
    width: 50%;
    display: flex;
    align-self:center; 
  }

  .form-row {
    flex-direction: column; 
  }

  .social-logo  {
    width: 40%;
    display: flex;
    align-items: center; 
  }
  .social-logo img {
    width: 40%;
    display: flex;
    align-items: center; 
  }
  
 .contact-info{
  font-size: small;
  display: flex;
  flex-direction: column;
  align-items: center; 
 }

 .last-two-lines {
  display: flex;
  flex-direction:row ;
  justify-content: space-around;
 }

 .mail { 
  font-family:  "Rubik", sans-serif;;
  font-weight: 800;
  text-decoration: none;
  margin: 10px;


 }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,uBAAuB;;;AAGzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;;EAEpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;CAED;EACC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;CAC9B;;CAEA;EACC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;;;CAGb;AACD","sourcesContent":[".contact-form-all {\r\n  background-color: white;\r\n  margin-bottom: 2%;\r\n  padding: 0.5%;\r\n}\r\n.contact-container {\r\n  display: grid;\r\n  grid-template-columns: 1.5fr 1fr; \r\n  gap: 1em;\r\n  background-color: white;\r\n  \r\n  \r\n}\r\n\r\n.blue-title {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 800;\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #11224E;\r\n  font-size: 2.2em; \r\n  margin-bottom: 0.5em; \r\n}\r\n\r\n.contact-info {\r\n  padding-left: 20%; \r\n}\r\n\r\ninput::placeholder { \r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-size: 1em; \r\n  font-weight: 500;\r\n  color: rgb(69, 69, 69);\r\n}\r\n\r\n.mail { \r\ntext-decoration: none;\r\n}\r\n\r\n.contact-info .about{\r\n  font-weight: 300;\r\n  font-size: 1.3em; \r\n  color: #11224E;\r\n  text-align: justify;\r\n}\r\n\r\n.contact-info .mail{\r\n  font-weight: bold;\r\n  font-size: 1.2em; \r\n  color: #11224E;\r\n  text-align: justify;\r\n}\r\n\r\n.contact-info .phone {\r\n  font-weight: lighter;\r\n  font-size: 1.3em; \r\n  color: #11224E;\r\n  text-align: justify;\r\n}\r\n\r\n.contact-form {\r\n  padding-right: 20%;\r\n  height: 110%;\r\n}\r\n\r\n.contact-form form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-top: 1em;\r\n}\r\n\r\n.contact-form input {\r\n  width: 40%;\r\n  border: none;\r\n  border-bottom: 0.10em solid #11224E; \r\n  font-size: 1em; \r\n  margin-bottom: 2.3em;\r\n}\r\n\r\n.form-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: none;\r\n  font-size: 1em; \r\n  margin-bottom: 2em;\r\n}\r\n\r\n\r\n#message {\r\n  width: 100%;\r\n}\r\n\r\n.contact-form button {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n  background-color: #c44e00;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 0.5em; \r\n  font-size: 1.5em; \r\n  font-weight: normal; \r\n  cursor: pointer;\r\n}\r\n\r\n.contact-form button:hover {\r\n  background-color: #d27000;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.200em; \r\n}\r\n\r\n.social-logo  { \r\n  display: flex;\r\n  width: 14em; \r\n  height: auto;\r\n}\r\n.social-logo img  { \r\n width: 40%;\r\n padding: 5%;\r\n}\r\n\r\n.notification {\r\n  position: fixed;\r\n  bottom: 0;  \r\n  right: 0;   \r\n  background-color: #c44e00;\r\n  color: #000;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000;\r\n  align-items: center;\r\n}\r\n\r\n.notification p {\r\n  margin: 10px;\r\n}\r\n\r\n.accessibility-link {\r\n  margin-top: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.accessibility-link a {\r\n  font-size: 1em;\r\n}\r\n\r\n.accessibility-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .contact-container {\r\n    display: flex;\r\n    flex-direction:column-reverse ;\r\n    grid-template-columns: 1fr; \r\n  }\r\n\r\n  .blue-title {\r\n    margin-bottom: 0.5em; \r\n    text-align: center;\r\n    \r\n  }\r\n\r\n  .contact-info,\r\n  .contact-form {\r\n    padding-inline: 5%; \r\n  }\r\n\r\n  .contact-form input,\r\n  #message,\r\n  .form-text {\r\n    width: 100%; \r\n  }\r\n\r\n  .contact-form button {\r\n    width: 50%;\r\n    display: flex;\r\n    align-self:center; \r\n  }\r\n\r\n  .form-row {\r\n    flex-direction: column; \r\n  }\r\n\r\n  .social-logo  {\r\n    width: 40%;\r\n    display: flex;\r\n    align-items: center; \r\n  }\r\n  .social-logo img {\r\n    width: 40%;\r\n    display: flex;\r\n    align-items: center; \r\n  }\r\n  \r\n .contact-info{\r\n  font-size: small;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; \r\n }\r\n\r\n .last-two-lines {\r\n  display: flex;\r\n  flex-direction:row ;\r\n  justify-content: space-around;\r\n }\r\n\r\n .mail { \r\n  font-family:  \"Rubik\", sans-serif;;\r\n  font-weight: 800;\r\n  text-decoration: none;\r\n  margin: 10px;\r\n\r\n\r\n }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
